import { Lock } from 'lucide-react';
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import type { VorgangDetail } from '@/types';

import { useVorgangLockContext } from '../../../features/vorgangLocking/VorgangLockProvider';

interface LockWarningAlertProps {
  vorgang: VorgangDetail;
  currentUser: string;
}

export const LockWarningAlert: React.FC<LockWarningAlertProps> = ({
  vorgang,
}) => {
  const lockInformation = useVorgangLockContext();

  if (!lockInformation.isLockedByOtherUser) return null;

  return (
    <Alert variant="warning">
      <Lock className="h-4 w-4" />
      <AlertTitle>Vorgang gesperrt</AlertTitle>
      <AlertDescription>
        Dieses Vorgang wird aktuell von {vorgang.lockedBy} bearbeitet. Sie
        können keine Änderungen vornehmen.
      </AlertDescription>
    </Alert>
  );
};
